import Vue from 'vue'
import { $$ } from '../_utils'

Vue.component('vue-timeline', {
  template: '#vue-timeline-template',
  props: ['steps', 'type'],
  data() {
    return {
      activeIndex: 0,
    }
  },
  methods: {
    setActiveIndex() {
      if (this.$props.steps) {
        this.activeIndex = this.$props.steps.findIndex(element => element.isActive === 'true')
      }
    },
  },
  created() {
    this.setActiveIndex()
  },
})

const timelines = $$('#vue-timeline-wrapper')
window.addEventListener('DOMContentLoaded', () => {
  if (!timelines) return
  timelines.forEach(element => {
    new Vue({
      el: element,
    })
  })
})
